import React from 'react'
import {ToolItemContainer} from './styled'
import {ToolItemImage, ToolItemLabel} from './styled'

export default function ToolItem({
  label,
  src,
  alt,
  redirectUrl,
  onClick,
  isActive,
}) {
  const props = redirectUrl
    ? {as: 'a', href: redirectUrl, target: '_blank', rel: 'noreferrer'}
    : {onClick}

  return (
    <ToolItemContainer {...props} data-active={isActive || undefined}>
      <ToolItemImage src={src} alt={alt} />
      <ToolItemLabel>{label}</ToolItemLabel>
    </ToolItemContainer>
  )
}
